/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralParameter } from '../../models/general-parameter';
import { GeneralParameterKey } from '../../models/general-parameter-key';

export interface GetGeneralParameter$Params {

/**
 * The referenced general parameter key
 */
  key: GeneralParameterKey;
}

export function getGeneralParameter(http: HttpClient, rootUrl: string, params: GetGeneralParameter$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralParameter>> {
  const rb = new RequestBuilder(rootUrl, getGeneralParameter.PATH, 'get');
  if (params) {
    rb.path('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneralParameter>;
    })
  );
}

getGeneralParameter.PATH = '/custom/parameters/{key}';
